<div class="hero">
  <div class="lonely-title">
    <h1>Tutti viaggi</h1>
    <span>Scopri tutti i viaggi di Social Travels e scegli quello che fa per
      te!</span>
  </div>
</div>
<div class="container">
  <div class="frm-container">
    <form [formGroup]="frmSearch" (ngSubmit)="submitSearch()">
      <div class="flex align-items-center justify-content-center gap-1">
        <h2>Cerca il <span class="green">tuo</span> viaggio</h2>
        <img src="assets/media/icons/airplane.png" width="30">
      </div>
      <div class="grid mt-0">
        <div class="col-12 md:col-3">
          <div class="search-input">
            <p-autoComplete [forceSelection]="true" formControlName="destinations" placeholder="Destinazione"
              [suggestions]="suggestedCountries" (completeMethod)="filterCountries($event)" field="name" dataKey="ISO"
              ngClass="frm mt-1" [emptyMessage]="'Nessun risultato trovato'"
              emptyFilterMessage="Nessun risultato trovato" [showClear]="true">
            </p-autoComplete>
          </div>
        </div>
        <div class="col-12 md:col-3">
          <div class="search-input">
            <p-multiSelect styleClass="w-full" [options]="types" optionLabel="name" optionValue="id" [showClear]="true"
              formControlName="categories" placeholder="Categorie" emptyMessage="Nessun risultato trovato.">
              <ng-template let-t pTemplate="type">
                <div class="flex align-items-center gap-2">
                  <img [src]="t.id | travelType" />
                  <span>{{ t.name }}</span>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div class="col-12 md:col-3">
          <p-calendar formControlName="from" styleClass="w-full" [showClear]="true" placeholder="Dal" appendTo="body" panelStyleClass="custom-calendar" [touchUI]="false"
            dateFormat="dd/mm/yy" [minDate]="today"></p-calendar>
        </div>
        <div class="col-12 md:col-3">
          <p-calendar formControlName="to" styleClass="w-full" [showClear]="true" placeholder="Al" dateFormat="dd/mm/yy" appendTo="body" panelStyleClass="custom-calendar" [touchUI]="false"
            [minDate]="today"></p-calendar>
        </div>
        <div class="col-12 md:col-3">
          <div class="mt-2">
            <p-autoComplete formControlName="leader" styleClass="w-full" [suggestions]="suggestedLeaders"
              (completeMethod)="filterLeaders($event)" placeholder="Organizzatore" dataKey="id" [forceSelection]="true"
              emptyMessage="Nessun risultato" emptyFilterMessage="Nessun risultato trovato"
              [optionLabel]="getLeadersNameToDisplay" [showClear]="true">
              <ng-template let-leader pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <p-avatar [image]="leader.profile_picture | imagePipe : 'user' : 'sm'" shape="circle"></p-avatar>
                  <div>{{ leader.name }} {{ leader.last_name }}</div>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>

        <!-- <div class="col-12 md:col">
            <div class="mt-2">
              <p-dropdown [options]="days_opts" ngClass="w-full" optionLabel="name" optionValue="value"
              formControlName="days" appendTo="body" placeholder="Giorni"></p-dropdown>
            </div>
          </div> -->
        <div class="col-12 md:col">
          <div class="mt-2">
            <p-dropdown [options]="price_opts" ngClass="w-full" optionLabel="value" optionValue="value"
              formControlName="price" appendTo="body" placeholder="Prezzo" [showClear]="true"></p-dropdown>
          </div>
        </div>
        <div class="col-12 md:col">
          <div class="flex align-items-center justify-content-center gap-3 mt-3">
            <p-inputSwitch formControlName="flight" inputId="flight" />
            <label for="flight" class="text-sm mb-1">Voli inclusi</label>
          </div>
        </div>

        <div class="col-12 md:col">
          <!-- <div class="mt-2"> -->
          <p-button styleClass="w-full slide mt-2" label="Filtra" size="small" type="submit"></p-button>
          <!-- </div> -->
        </div>

      </div>

    </form>
  </div>

  <div class="mt-6 ">
    <div class="flex align-items-center justify-content-end">
      <div class="order-container ">
        <p-dropdown [options]="orderBy" placeholder="Ordina per..." [formControl]="orderBy_control" optionLabel="name"
        optionValue="value" [showClear]="true" styleClass="w-full"></p-dropdown>
      </div>
    </div>

    @if(loading){
    <div class="backdrop-mini-loader">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    </div>
    }@else {
      <div class="grid">
        @for (t of travels; track $index) {
        <div class="col-12 md:col-6 lg:col-3">
          <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
        </div>
        }
      </div>
  
      @if(totalRecords === 0){
      <div class="flex align-items-center justify-content-center mt-7 mb-6">
        <div class="empty-set px-0">
          <img src="/assets/media/illustrations/map.png" height="200">
          <h5>Nessun risultato</h5>
        </div>
      </div>
      } @if(totalRecords > travels.length){
      <div class="flex align-items-center justify-content-center mt-7">
        <p-button label="Mostra altro" styleClass="slide px-6" size="small" (click)="showMore()"></p-button>
      </div>
      }
    }

  </div>

  <!-- <pre>{{frmSearch.value | json}}</pre> -->

  <div class="join mt-6 mb-4">
    <app-leaving></app-leaving>
</div>
